import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";

import DeleteIcon from '../../../Image/TermsDelete.png';
import ExitIcon from '../../../Image/ExitIcon.png';

export default function DeleteModal (props) {
  const { 
    provisionId,
    onClickDelete,
    onClickExit
   } = props;

  // 삭제하기 버튼 //
  function handleDeleteClick() {
    const mergedProvision = {
      id : provisionId,
    };

    onClickDelete(mergedProvision);
  }


  
  return (
    <TopLevelWrapper>
      <Modal>
        <RedCircleWrapper>
          <EmptyBox/>
          <RedCircleImgBox>
            <RedCircleImg src={DeleteIcon}/>
          </RedCircleImgBox>
          <ExitButton onClick={onClickExit}>
            <ExitImg src={ExitIcon}/>
          </ExitButton>
        </RedCircleWrapper>

        <TextWrapper>
          <TitleText>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#000000' hover='default'>규정 삭제하기</Text>
          </TitleText>
          <ExplainText>
            <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#595959' hover='default'>규정을 삭제하시면 되돌릴 수 없습니다.</Text>
            <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#595959' hover='default'>삭제를 진행하시겠습니까?</Text>
          </ExplainText>
        </TextWrapper>

        <ButtonWrapper>
          <CancleButton onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' hover='pointer'>취소</Text>
          </CancleButton>
          <DeleteButton onClick={handleDeleteClick}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' hover='pointer'>삭제하기</Text>
          </DeleteButton>
        </ButtonWrapper>
      </Modal>
    </TopLevelWrapper>
  );
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 99;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const Modal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  z-index: 100;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const RedCircleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: -43px;
  padding: 0px 8px;

  width: calc(100% - 16px);
`;

const EmptyBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;
`;

const RedCircleImgBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #FF3131;
`;

const RedCircleImg = styled.img`
  width: 47px;
  height: 47px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 36px;

  width: 20px;
  height: 20px;

  :hover {
    cursor: pointer;
  }
`;

const ExitImg = styled.img`
  width: 20px;
  height: 20px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 53%;
`;

const TitleText = styled.div`
  display: flex;
`;

const ExplainText = styled.div`
  display: flex;
  flex-direction: column;

  margin-top : 10px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 52px;
`;

const CancleButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  border-bottom-left-radius: 15px;
  background-color: #CFCFCF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    background-color: #6DD49E;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  border-bottom-right-radius: 15px;
  background-color: #CFCFCF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    background-color: #FF3131;
  }
`;

const Text = styled.p`
  align-self: center;

  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;